const url = 'https://mindfulappy.azurewebsites.net/api';
//const url = 'http://localhost:7071/api';

const api = {
    auth: `${url}/auth`,
    SMSAuth: `${url}/smsauth`,
    company: `${url}/company`,
    administrators: `${url}/employee`,
    error: `${url}/portalerror`,
    group: `${url}/group`,
    member: `${url}/member`,
    project: `${url}/project`,
    projectstats: `${url}/projectstats`,
    pulse: `${url}/pulse`,
};

export default api;
